"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetDeviceByTypeAndPosition = exports.useGetDeviceByPdid = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.json.stringify.js");
var _react = require("react");
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/selectors");
var _useGetComponentsByParams = require("./useGetComponentsByParams");
var _paulCorePackage = require("paul-core-package");
const useGetDeviceByTypeAndPosition = props => {
  const {
    equipmentType = '',
    equipmentId = '',
    thingLoopType,
    thingSectionType,
    thingProductDisplayClassification = '',
    thingProductDisplayClassificationNot = ''
  } = props;
  const equipment = (0, _useGetComponentsByParams.useGetComponentByTypeAndId)({
    type: equipmentType,
    id: equipmentId
  });
  const devicesById = (0, _reactRedux.useSelector)(_selectors.selectDevicesById) || {};
  const device = Object.values(devicesById).find(d => {
    var _equipment$devicesId, _d$thingLoopType, _d$thingSectionType;
    return d.equipmentType === equipmentType && (equipmentId ? equipment === null || equipment === void 0 || (_equipment$devicesId = equipment.devicesId) === null || _equipment$devicesId === void 0 ? void 0 : _equipment$devicesId.includes(d.thingPDIDDevice) : true) && Number((_d$thingLoopType = d.thingLoopType) === null || _d$thingLoopType === void 0 ? void 0 : _d$thingLoopType.id) === Number(thingLoopType) && Number((_d$thingSectionType = d.thingSectionType) === null || _d$thingSectionType === void 0 ? void 0 : _d$thingSectionType.id) === Number(thingSectionType) && (thingProductDisplayClassification ? thingProductDisplayClassification === _paulCorePackage.functions.getDisplayClassification(d.thingProductDisplayClassification) : true) && (thingProductDisplayClassificationNot ? thingProductDisplayClassificationNot !== _paulCorePackage.functions.getDisplayClassification(d.thingProductDisplayClassification) : true);
  }) || null;
  return (0, _react.useMemo)(() => device, [JSON.stringify(device)]);
};
exports.useGetDeviceByTypeAndPosition = useGetDeviceByTypeAndPosition;
const useGetDeviceByPdid = _ref => {
  let {
    thingPDIDDevice = null
  } = _ref;
  const device = ((0, _reactRedux.useSelector)(_selectors.selectDevicesById) || {})[thingPDIDDevice] || null;
  return (0, _react.useMemo)(() => device, [JSON.stringify(device)]);
};
exports.useGetDeviceByPdid = useGetDeviceByPdid;